var _path, _path2, _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoprincipal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    svgjs: "http://svgjs.dev/svgjs",
    width: 150,
    height: 30,
    viewBox: "0 0 1500 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.9090909090909918,0.6313416308613284)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 111",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 420,
    width: 1500,
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.16685457387049496)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 111.33370914774098",
    height: 111.33370914774098,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 573.0511115931592 161.30639609856001",
    height: 111.33370914774098,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,177.5311115931592,25.596814049280013)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 110.11276799999999",
    height: 110.11276799999999,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 110.11276799999999",
    height: 110.11276799999999,
    width: 395.52,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 110.11276799999999",
    height: 110.11276799999999,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "3.3 -34.4 124.99 34.8",
    height: 110.11276799999999,
    "data-palette-color": "#091627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.65-34.4L27.05-34.4 27.05-15.25Q27.05-8.45 26.3-5.33 25.55-2.2 23.1-0.9 20.65 0.4 15.2 0.4L15.2 0.4Q9.75 0.4 7.28-0.9 4.8-2.2 4.05-5.35 3.3-8.5 3.3-15.25L3.3-15.25 3.3-34.4 9.7-34.4 9.7-13.25Q9.7-9.3 10-7.75 10.3-6.2 11.38-5.65 12.45-5.1 15.2-5.1L15.2-5.1Q17.95-5.1 19.03-5.65 20.1-6.2 20.38-7.73 20.65-9.25 20.65-13.25L20.65-13.25 20.65-34.4ZM47.05 0L40.65 0 40.65-12.2 30.5-34.4 37.15-34.4 43.85-19.05 44.2-19.05 50.8-34.4 57.25-34.4 47.05-12.2 47.05 0ZM92.95 0L84.59 0 79.3-24.75 79.09-24.75 73.8 0 65.45 0 58.5-34.4 64.95-34.4 69.84-7.4 70.15-7.4 75.8-34.4 82.9-34.4 88.59-7.4 88.9-7.4 93.59-34.4 99.95-34.4 92.95 0ZM128.29 0L121.74 0 119.64-7.7 108.39-7.7 106.34 0 99.94 0 109.69-34.4 118.54-34.4 128.29 0ZM118.14-13.2L114.14-28.35 113.89-28.35 109.84-13.2 118.14-13.2Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#091627",
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 151.53612977479122 161.30639609856001",
    height: 161.30639609856001,
    width: 151.53612977479122,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "4.592816031821727 1.8375840794349685 91.03986998388703 96.90965019502076",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    height: 161.30639609856001,
    width: 151.53612977479122,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.292 40.878C65.497 44.762 63.72 47.571 62.247 50.482 61.205 52.54 61.815 53.642 63.404 54.662 67.093 57.031 70.812 59.362 74.525 61.696 76.001 62.622 77.295 63.646 77.439 65.588 77.617 67.975 76.098 69.001 74.179 69.604 72.616 70.094 71.538 70.901 72.267 72.6 73.111 74.561 74.598 73.499 75.807 72.978 77.082 72.424 78.28 71.696 79.514 71.042 80.713 70.403 82.018 70.229 82.495 71.717 82.929 73.075 81.449 73.093 80.6 73.456 78.749 74.243 76.49 74.219 74.985 76.13 77.391 77.389 79.688 76.436 81.922 76.569 82.871 76.625 84.315 76.296 84.39 77.569 84.483 79.122 82.929 78.907 81.906 78.89 80.414 78.866 78.924 78.646 77.434 78.512 76.963 78.47 76.4 78.209 76.163 78.87 75.963 79.429 76.355 79.802 76.726 80.141 77.803 81.12 79.188 81.396 80.52 81.803 81.141 81.993 82.143 81.92 81.988 82.896 81.837 83.833 80.874 84.093 80.098 83.92 79.044 83.683 77.935 83.339 77.06 82.737 71.21 78.712 64.452 77.511 57.678 76.278 55.798 75.934 53.143 76.185 52.604 73.954 52.058 71.689 54.547 70.753 56.096 69.593 57.927 68.22 59.882 67.008 61.718 65.64 63.228 64.516 63.003 63.951 61.187 63.159 53.689 59.889 46.111 60.235 38.426 62.154 37.751 62.322 37.05 62.488 36.364 62.476 32.044 62.4 31.567 62.649 33.203 67.453 34.582 71.5 36.468 75.374 37.899 79.407 39.108 82.821 38.596 83.727 35.379 85.32 32.584 86.702 29.553 87.38 26.546 88.034 21.315 89.173 17.314 92.115 13.924 96.08 13.341 96.763 12.794 97.484 12.143 98.097 11.315 98.872 10.199 99.001 9.448 98.229 8.771 97.534 9.53 96.708 10.059 96.159 11.012 95.174 12.078 94.299 13.694 92.836 10.669 92.97 8.476 93.097 6.28 93.141 5.656 93.153 4.699 93.399 4.601 92.407 4.505 91.442 5.268 90.964 6.132 90.939 8.124 90.88 10.118 90.944 12.112 90.924 12.782 90.917 13.669 91.064 13.814 90.137 13.979 89.096 13.137 88.782 12.312 88.681 10.729 88.491 9.122 88.472 7.556 88.196 6.575 88.026 5.521 87.536 5.841 86.215 6.118 85.069 7.088 85.044 8.02 85.308 9.933 85.852 11.824 86.471 13.738 87.012 15.096 87.397 16.252 87.568 15.43 85.44 15.184 84.798 14.347 83.801 15.219 83.321 16.21 82.772 16.99 83.813 17.191 84.626 18.129 88.402 20.242 87.79 22.879 86.477 25.555 85.14 28.229 83.831 30.795 82.281 32.575 81.203 32.972 79.96 32.357 78.048 31.556 75.562 30.394 73.265 29.171 70.978 27.719 68.259 26.105 65.616 25.338 62.569 24.287 58.389 24.876 57.249 29.148 56.226 32.92 55.325 36.724 54.541 40.531 53.793 44.649 52.983 45.071 52.405 43.747 48.536 41.874 43.072 41.782 37.747 43.735 32.168 45.305 27.684 45.52 27.86 40.895 26.392 34.259 24.286 28.494 20.921 25.817 13.87 25.033 11.807 23.163 11.151 21.025 10.859 19.494 10.649 16.591 11.042 16.912 9.106 17.312 6.682 19.456 8.969 20.822 9.05 21.769 9.106 22.747 9.289 23.229 8.428 23.664 7.65 22.902 6.955 22.404 6.353 21.466 5.227 20.073 4.295 20.785 2.5 20.975 2.017 21.376 1.678 21.958 1.915 23.652 2.605 23.691 4.187 23.941 5.655 24.069 6.411 23.909 7.601 24.899 7.589 26.394 7.572 25.486 6.228 25.683 5.485 25.834 4.91 25.882 4.305 26.026 3.727 26.228 2.917 26.598 2 27.57 2.298 28.814 2.678 27.898 3.595 27.755 4.273 27.611 4.954 27.329 5.602 27.182 6.282 26.592 9.032 27.331 9.859 30.11 10.083 31.427 10.188 33.822 9.171 33.818 11.114 33.815 13.221 31.418 12.043 30.111 12.131 28.299 12.253 27.88 12.858 28.988 14.24 33.245 19.546 38.979 21.979 45.611 22.54 47.313 22.684 47.852 21.338 48.052 20.04 48.276 18.572 48.274 17.053 48.23 15.561 48.135 12.299 49.264 9.483 51.314 7.044 53.619 4.306 56.281 1.748 60.182 2.638 64.473 3.618 67.153 6.717 68.531 10.843 69.338 13.259 69.186 15.815 68.803 18.265 68.321 21.345 68.399 24.439 68.206 27.52 68.061 29.827 68.308 32.048 70.107 33.896 71.304 35.125 71.548 36.917 72.009 38.551 73.433 43.591 79.104 46.485 84.08 44.686 86.165 43.933 87.294 42.409 87.276 40.131 87.274 39.419 87.269 38.671 88.064 38.361 88.546 38.173 89.042 38.329 89.415 38.744 90.103 39.507 89.422 39.965 89.063 40.538 88.558 41.343 88.349 42.332 89.019 43.035 89.672 43.725 90.477 42.957 91.213 42.794 92.708 42.458 94.559 39.985 95.51 42.058 96.261 43.694 93.374 43.95 92.013 44.728 91.169 45.208 89.416 44.955 89.76 46.513 90.026 47.71 91.443 47.708 92.545 47.785 92.942 47.814 93.347 47.773 93.739 47.829 94.466 47.934 95.59 47.668 95.427 48.902 95.32 49.709 94.427 49.917 93.73 49.646 88.936 47.792 84.104 49.517 79.295 49.49 73.785 49.456 69.571 47.635 67.385 42.27 67.252 41.937 66.936 41.681 66.292 40.878M64.204 73.093C65.316 74.036 66.528 74.402 67.804 74.441 69.042 74.478 69.583 73.534 69.569 72.507 69.549 71.039 68.384 71.469 67.655 71.764 66.584 72.195 65.26 71.896 64.204 73.093",
    fill: "#5ebc67",
    "data-fill-palette-color": "accent"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 111.33370914774098,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoprincipal);
export default __webpack_public_path__ + "static/media/logoprincipal.4f1c63f3871c160a1e2e90e9c2d514dd.svg";
export { ForwardRef as ReactComponent };